import React from "react";

function NetworkIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="33"
            fill="none"
            viewBox="0 0 34 33"
        >
            <mask
                id="mask0_0_5184"
                style={{ maskType: "alpha" }}
                width="34"
                height="33"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path fill="#D9D9D9" d="M0.906 0H33.164V32.258H0.906z"></path>
            </mask>
            <g mask="url(#mask0_0_5184)">
                <path
                    fill="#000"
                    d="M25.716 8.903a11.265 11.265 0 00-8.668-4.065c-3.48 0-6.59 1.58-8.664 4.06a.416.416 0 00-.081.1 11.231 11.231 0 00-2.545 7.13c0 2.702.957 5.19 2.547 7.135a.421.421 0 00.076.091 11.265 11.265 0 008.667 4.065c3.48 0 6.59-1.58 8.665-4.06a.414.414 0 00.081-.1 11.231 11.231 0 002.545-7.13c0-2.702-.957-5.19-2.548-7.134a.422.422 0 00-.075-.092zm-.43 13.475a12.096 12.096 0 00-2.318-1.108c.427-1.412.684-2.991.725-4.665h3.686a10.27 10.27 0 01-2.096 5.773h.003zm-18.57-5.776h3.686a17.67 17.67 0 00.724 4.668c-.846.306-1.628.676-2.317 1.109a10.289 10.289 0 01-2.096-5.774l.003-.003zm2.095-6.72c.69.433 1.472.803 2.318 1.11a17.649 17.649 0 00-.725 4.664H6.715a10.269 10.269 0 012.096-5.774zm8.711 5.774v-3.697a17.957 17.957 0 004.562-.684c.387 1.317.622 2.804.663 4.38h-5.225zm0-4.643v-5.19c1.777.265 3.324 2.01 4.268 4.554a16.99 16.99 0 01-4.268.636zm-.947 0a17.032 17.032 0 01-4.267-.636c.941-2.545 2.49-4.289 4.267-4.554v5.19zm0 .946v3.697h-5.224c.04-1.577.276-3.064.662-4.38 1.407.408 2.956.645 4.563.683zm-5.224 4.643h5.224V20.3a17.957 17.957 0 00-4.562.684 17.224 17.224 0 01-.662-4.38zm5.224 4.644v5.19c-1.776-.266-3.323-2.01-4.267-4.555a16.99 16.99 0 014.267-.635zm.947 0c1.506.038 2.956.257 4.267.635-.94 2.545-2.49 4.29-4.267 4.554v-5.19zm0-.947v-3.697h5.225a17.224 17.224 0 01-.663 4.381 17.975 17.975 0 00-4.562-.684zm6.171-4.643a17.67 17.67 0 00-.725-4.668 12.09 12.09 0 002.318-1.108 10.288 10.288 0 012.096 5.773h-3.686l-.003.003zm-1.028-5.563c-.581-1.555-1.379-2.85-2.323-3.767a10.354 10.354 0 014.33 2.82c-.6.366-1.277.682-2.007.947zm-11.233 0a11.254 11.254 0 01-2.007-.946 10.386 10.386 0 014.33-2.82c-.944.916-1.742 2.214-2.323 3.766zm0 12.07c.581 1.555 1.38 2.85 2.323 3.767a10.354 10.354 0 01-4.33-2.82 11.28 11.28 0 012.007-.947zm11.233 0c.73.265 1.407.581 2.007.946a10.386 10.386 0 01-4.33 2.82c.944-.916 1.742-2.214 2.323-3.766z"
                ></path>
            </g>
        </svg>
    );
}

export default NetworkIcon;
